<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">SEO</li>
        <li class="breadcrumb-item">Blog</li>
        <li class="breadcrumb-item"><router-link :to="{name: 'seo-blog-record-meta'}">Posts</router-link></li>
        <li class="breadcrumb-item active">{{ record.title }}</li>
      </ol>
    </div>
    <form action="/api/admin/blog/records/save" method="POST" @submit.prevent="saveRecord()">
      <div class="card">
        <div class="card-body">
          <h3 class="page-title">Edit blog post #{{ record.id }} meta</h3>
          <div class="form-group">
            <label>Title</label>
            <input v-model.trim="record.meta_title" class="form-control" >
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea v-model.trim="record.meta_description" class="form-control"/>
          </div>
          <div class="form-group">
            <label>Canonical</label>
            <input v-model.trim="record.canonical" class="form-control" >
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h3 class="page-title">Open Graph</h3>
          <div class="form-group">
            <label>Title</label>
            <input v-model.trim="record.og_title" class="form-control" >
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea v-model.trim="record.og_description" class="form-control"/>
          </div>
          <div class="form-group">
            <label>Type</label>
            <input v-model.trim="record.og_type" class="form-control" >
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <h3 class="page-title">Twitter Cards</h3>
          <div class="form-group">
            <label>Card</label>
            <input v-model.trim="record.twitter_card" class="form-control" >
          </div>
          <div class="form-group">
            <label>Title</label>
            <input v-model.trim="record.twitter_title" class="form-control" >
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea v-model.trim="record.twitter_description" class="form-control"/>
          </div>
          <div class="form-group">
            <label>Image</label>
            <input v-model.trim="record.twitter_image" class="form-control" >
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <button type="button" class="btn btn-primary" @click="goBack">Back</button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* global axios, toastr */
export default {
  name: 'BlogRecordsEdit',
  data () {
    return {
      record: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    let route = '/api/admin/blog/records/' + to.params.recordId
    axios
      .get(route)
      .then(repsonse => {
        next(vm => (vm.record = repsonse.data.record))
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  methods: {
    saveRecord () {
      let formData = new FormData()
      for (var key in this.record) {
        if (key === 'categories') {
          let categories = this.record[key].map(item => item.id)
          formData.append(key, categories)
        } else {
          formData.append(key, this.record[key])
        }
      }

      axios
        .post('/api/admin/blog/records/save', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            this.record = response.data.record
            toastr['success']('Changes have been saved successfully')
          } else {
            let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
            toastr['error'](message)
          }
        })
        .catch(error => {
          let message = (error && error.message) || 'Something goes wrong'
          toastr['error'](message)
        })
    },
    goBack () {
      this.$router.push('/admin/seo/blog-record-meta')
    }
  }
}
</script>

<style>
</style>
